import React from 'react';

import './Button.css';

type ButtonBaseProps = {
    label: string;
    variant?: 'primary' | 'sliding' | 'accent';
    icon?: React.ReactNode;
    className?: string;
    onMouseEnter?: React.MouseEventHandler<HTMLElement>;
    onMouseLeave?: React.MouseEventHandler<HTMLElement>;
};

type ButtonAsLink = ButtonBaseProps & {
    href: string;
    target?: string;
    rel?: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    type?: never;
};

type ButtonAsButton = ButtonBaseProps & {
    href?: never;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    type?: 'button' | 'submit';
    disabled?: boolean;
};

type ButtonProps = ButtonAsLink | ButtonAsButton;

function isLinkProps(props: ButtonProps): props is ButtonAsLink {
    return typeof (props as ButtonAsLink).href === 'string';
}

export function Button(props: ButtonProps) {
    const { label, variant = 'primary', icon, className, onMouseEnter, onMouseLeave } = props;
    const classes = `btn btn--${variant}${className ? ` ${className}` : ''}`;

    const content = (
        <>
            <span className="btn__label">{label}</span>
            {icon && <span className="btn__icon">{icon}</span>}
        </>
    );

    if (isLinkProps(props)) {
        const { href, target, rel, onClick } = props;
        return (
            <a
                href={href}
                target={target}
                rel={rel}
                className={classes}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                {content}
            </a>
        );
    }

    const { onClick, type, disabled } = props;
    return (
        <button
            type={type ?? 'button'}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            className={classes}
            disabled={disabled}
        >
            {content}
        </button>
    );
}
